import { RetailerTranslations } from "@narvar/nth-hook-loma";
import { RetailerThemeStyles } from "@narvar/nth-hook-theme";

export const themeTokens: (keyof RetailerThemeStyles)[] = [
  "panelcontainerNoneNone",
  "panelcontainerNoneHover",
  "panelcontainerNoneActive",
  "linksNoneDefault",
  "linksNoneHover",
  "buttonsPrimaryDefault",
  "buttonsPrimaryHover",
  "documentbodyNoneNone",
  "bodytextDefaultNone",
  "selecteditemNoneNone",
];

export const translationKeys: (keyof RetailerTranslations)[] = [
  "returnsItemListItemInfoskuLabel",
  "returnsItemListItemInfopriceLabel",
  "returnsItemListItemInfoqtyLabel",
  "returnsItemListItemInfocolorLabel",
  "returnsItemListItemInfosizeLabel",
  "returnsItemListItemInforeasonLabel",
  "returnsItemListSubmit",
  "returnsItemListIneligibleTitle",
  "returnsItemListTitleDirty",
  "returnsItemListTitleDirtyHipaa",
  "returnsItemListTitleHipaa",
  "returnsItemListTitle",
  "returnsActionsBackToLogin",
  "returnsItemListReturnInitiatedTitle",
  "returnsItemListPendingCancelReturnLink",
  "returnsItemListIneligibleDescription",
];
